import { mapGetters } from "vuex";
import { PERMISSIONS } from "@/constants/roles";

// สิทธิ์จัดการ "แบบฟอร์มคลินิก" (mediaFile category "Template") — เพิ่ม/ลบได้เฉพาะ
// ผู้จัดการสาขา (MANAGER) และผู้บริหารระดับคลินิก (RDM / C_LEVEL)
//
// ใช้ can() ไม่ใช่ getIsAccessMenu(): getIsAccessMenu รู้จักแค่ branch role id 1-7
// จึงตัด RDM (101) / C_LEVEL (102) ทิ้งทุกกรณี
//
// can() คืน false ระหว่าง permissionContext ยังโหลดไม่เสร็จ — ปุ่มจะโผล่ช้าเสี้ยว
// วินาทีหลังเข้าหน้า ซึ่งเป็น tradeoff เดียวกับ Sidebar/BranchMembers ที่ใช้อยู่แล้ว
// (router ยิง ensureClinicPermissionContext ให้ทุกหน้าที่มี param clinicUrl)
//
// อัปโหลดแบบฟอร์มใหม่และเซ็นแบบฟอร์มเก็บเข้าแฟ้มต้องมีสิทธิ์ DOCUMENT_GENERATOR
// (BASIC / PRO / PREMIUM / แพ็กเดิม — FREE ไม่มี) ผ่าน getter canGenerateDocument
// แทนการเทียบชื่อแพ็ก เพื่อให้ตามสิทธิ์จริงจาก entitlements (รวมแพ็กเดิม/เส้นทางถอย)
// ลบแบบฟอร์มที่มีอยู่แล้วไม่ติดแพ็ก (เป็นงานจัดการ ไม่ใช่ฟีเจอร์ที่ขาย)
//
// เดิมเซ็นแบบฟอร์มไม่ติดแพ็ก — เปลี่ยนตามกติกา 2026-10-14: FREE อัปโหลดไฟล์ได้
// แต่ออกเอกสารและเซ็นเก็บเข้าแฟ้มไม่ได้ (ยกเว้นใบรับรองแพทย์)
export default {
  computed: {
    ...mapGetters({
      canGetter: "moduleUser/can",
      branchInfoForClinicForm: "moduleUser/getBranchInfo",
      canGenerateDocumentForClinicForm: "moduleBranch/canGenerateDocument",
    }),
    canManageClinicForm() {
      return this.canGetter(PERMISSIONS.MEDIAFILE_TEMPLATE_MANAGE, {
        clinicId: this.branchInfoForClinicForm?.clinic?.id,
        branchId: this.branchInfoForClinicForm?.id,
      });
    },
    hasClinicFormPlan() {
      return this.canGenerateDocumentForClinicForm;
    },
    canUploadClinicForm() {
      return this.canManageClinicForm && this.hasClinicFormPlan;
    },
  },
};
